// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  HttpMethod,
  RestAuthType,
} from "./types";


export default __t.row({
  endpointId: __t.u64().primaryKey().name("endpoint_id"),
  name: __t.string(),
  description: __t.string(),
  url: __t.string(),
  get method() {
    return HttpMethod;
  },
  headersJson: __t.string().name("headers_json"),
  queryParamsJson: __t.string().name("query_params_json"),
  pathParamsJson: __t.string().name("path_params_json"),
  bodyTemplate: __t.string().name("body_template"),
  get authType() {
    return RestAuthType.name("auth_type");
  },
  enabled: __t.bool(),
  createdAt: __t.timestamp().name("created_at"),
  createdBy: __t.string().name("created_by"),
  updatedAt: __t.timestamp().name("updated_at"),
  specId: __t.option(__t.u64()).name("spec_id"),
});
